import useUser from 'shared/hooks/use-user'
import { useLocoTranslation } from './use-loco-translation'

interface OpenAuthWindowProps {
  locationHref: string
  onError: (_: Error) => void
  subscribeOnMessageFromCallbackPage: (_: WindowProxy) => void
}

export const useOAuthLogin = () => {
  const { user } = useUser()
  const { t } = useLocoTranslation()

  const openAuthWindow = async ({
    locationHref,
    onError,
    subscribeOnMessageFromCallbackPage,
  }: OpenAuthWindowProps) => {
    if (!user) return

    try {
      const initialPath = `${window.location.origin}/dashboard/oauth-callback`

      const width = 500
      const height = 600
      const screenWidth = window.screen.width
      const screenHeight = window.screen.height
      const left = screenWidth / 2 - width / 2
      const top = screenHeight / 2 - height / 2

      const authWindow = window.open(
        initialPath,
        '_blank',
        `width=${width},height=${height},left=${left},top=${top}`,
      )
      if (!authWindow) throw new Error(t('global.window_open_failed'))

      authWindow.location.href = locationHref

      subscribeOnMessageFromCallbackPage(authWindow)
    } catch (e) {
      onError(e as unknown as Error)
    }
  }

  return { openAuthWindow }
}
